<template>
  <div :class="{'fg-popup': popup, 'showing': popup && popupState.show}">
    <div class="fgp-container">
      <div class="fgp-title" v-if="popup">
        <div class="actions">
          <button class="clean call-to-action" @click="hidePopup()">Close</button>
        </div>
      </div>
      <div class="fgp-body">
        <div class="game-team card inv">
          <loading-state :state="state"></loading-state>
          <div class="game-team-content" v-if="gameTeam">
            <h2>{{gameTeam.team_owner.name}}'s Team</h2>
            <p>
              Team updated at <span>{{gameTeam.team.updated}}</span>
              <br>
              Points updated at <span>{{gameTeam.points.updated}}</span>
            </p>
            <table>
              <tbody>
                <tr
                  v-for="(playerKey, i) in gameTeam.team.team.players"
                  :key="playerKey"
                >
                  <td>
                    <span class="name" v-if="gamePoints.players[playerKey]">{{gamePoints.players[playerKey].player.name}}</span>
                    <span class="name-missing" v-else>NF {{playerKey}}</span>
                    <span class="boost-index" v-if="gameTeam.team.team.boost_players.indexOf(playerKey) > -1">
                      <sub>[{{gameTeam.team.team.boost_players.indexOf(playerKey) + 1}}]</sub>
                    </span>
                  </td>
                  <td class="points">
                    <span v-if="gameTeam.points.player_points">{{gameTeam.points.player_points[i]}}</span>
                    <span v-else>0</span>
                  </td>
                </tr>
                <tr class="total">
                  <td>Total</td>
                  <td>{{gameTeam.points.points}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { DataState } from '@/state'
import { GamePoints, GameTeam } from '@/models/fantasygame/core'

export default {
  props: {
    gamePoints: Object,
    teamKey: String,
    gameKey: String,
    popup: {
      type: Boolean,
      default: true
    },
    popupState: {
      type: Object,
      default () {
        return {
          show: true
        }
      }
    }
  },

  data () {
    return {
      state: DataState.newLoading(),
      gameTeam: null
    }
  },
  watch: {
    'teamKey' (to, from) {
      if (to !== from) {
        this.prepareToReopen()
        this.onViewOpenned()
      } else {
        this.refreshView()
      }
    }
  },
  mounted () {
    this.onViewOpenned()
  },
  methods: {
    onViewOpenned () {
      if (!this.teamKey) {
        return
      }

      if (!this.gamePoints.player_keys) {
        GamePoints.fetch(this.gameKey).then((resp) => {
          this.$emit('update:gamePoints', resp)
          return this.fetchGameTeam()
        }).catch((error) => {
          console.error(error)
          this.state.changeToError(error)
        })
      } else {
        this.fetchGameTeam().catch((error) => {
          this.state.changeToError(error)
        })
      }
    },

    fetchGameTeam () {
      return GameTeam.fetch(this.gameKey, this.teamKey).then((resp) => {
        this.gameTeam = resp
        this.state.changeToLoaded()
      })
    },

    prepareToReopen () {
      this.gameTeam = null
      this.state = DataState.newLoading()
    },

    refreshView () {

    },

    hidePopup () {
      this.popupState.show = false
      // this.prepareToReopen()
    }
  }
}
</script>